import React, {PureComponent} from 'react';
import './header.scss';
import pubsub from 'common/js/pubsub'

export default class Header extends PureComponent {
	constructor(props) {
		super(props);

		this.closeLoginPanel = this.closeLoginPanel.bind(this);
	}

	closeLoginPanel(e) {
		e.stopPropagation();
		pubsub.publish('hideLogin');
	}

	render() {
		return (
			<header className="m-login-header">
				<h3>{this.props.title || '登录'}</h3>
				<a onClick={this.closeLoginPanel} href="javascript:void(0)" className="close"></a>
			</header>
		)
	}
}



// WEBPACK FOOTER //
// ./src/views/login/header/Header.jsx